// src/config/mapConfig.js

// Cesium Ion Token is loaded from environment variables
const CESIUM_ION_TOKEN = process.env.REACT_APP_CESIUM_ION_TOKEN;

export const mapConfig = {
  // API Configuration
  apiBaseUrl: process.env.REACT_APP_API_URL,
  apiEndpoints: {
    organizations: '/organizations',
    assetCategories: '/asset-categories',
    networks: '/networks',
    sections: '/sections',
    assetTypes: '/asset-types',
    assetSubtypes: '/asset-subtypes',
    assets: '/assets',
    assetsCount: '/assets/count',
  },

  // Cesium Configuration
  cesiumIonToken: CESIUM_ION_TOKEN,
  initialCamera: {
    longitude: 102.27531447081842,
    latitude: 4.187990900821296,
    height: 2500000
  },

  // Terrain Configuration
  terrain: {
    // Default terrain provider
    defaultProvider: 'cesium-world-terrain', // Changed from ellipsoid to cesium-world-terrain as default
    
    // Available terrain providers
    providers: [
      {
        id: 'cesium-world-terrain',
        name: 'Cesium World Terrain',
        description: 'High-quality global terrain data',
        icon: 'terrain',
        type: 'cesium-ion',
        assetId: 1,
        options: {
          requestWaterMask: true,
          requestVertexNormals: true
        },
        requiresToken: true
      },
      {
        id: 'ellipsoid',
        name: 'Ellipsoid (Flat)',
        description: 'Perfect sphere - no terrain elevation',
        icon: 'public',
        type: 'ellipsoid',
        options: {}
      }
      // Temporarily disabled until terrain data is available
      /*
      {
        id: 'malaysia-terrain',
        name: 'Malaysia High-Res Terrain',
        description: 'High-resolution terrain for Malaysia region',
        icon: 'landscape',
        type: 'custom-url',
        url: '/terrain/malaysia/',
        options: {
          requestWaterMask: false,
          requestVertexNormals: true
        },
        region: {
          // Bounds for Malaysia region
          west: 99.0,
          south: 1.0,
          east: 120.0,
          north: 8.0
        }
      }
      */
    ],
    
    // Performance settings
    performance: {
      maximumScreenSpaceError: 2,        // Quality vs performance trade-off
      tileCacheSize: 100,                // Number of terrain tiles to cache
      preloadAncestors: true,            // Preload parent tiles for smoother transitions
      preloadSiblings: true              // Preload sibling tiles
    }
  },

  // 3D Tilesets (from Cesium Ion)
  // Static Data Layers (relative to /public)
  layers: {
    // perlisRoadsGeoJson: '/perlis_road_lines.geojson', // Disabled
    // lpt2RoadsGeoJson: '/reference/PLUS_Networks_Lite.geojson', // Removed - now dynamic per organization
    sgTebuJalanGeoJson: '/SgTebu_geojson/jalan.geojson',
    sgTebuKadasterGeoJson: '/SgTebu_geojson/kadaster.geojson',
    sgTebuSungaiGeoJson: '/SgTebu_geojson/sungai.geojson',
  },

  // Truck Animations Configuration (Now an array)
  animations: [
    {
      id: 'originalAnimation', // Unique ID for this animation
      czmlPath: '/NSE.czml', // Changed from road_789807528.czml to NSE.czml
      truckModelPath: '/CesiumMilkTruck.glb',
      durationSeconds: 360,
      roadEntityId: 'path-80b74d6b', // Updated to match the entity ID in NSE.czml
      truckEntityId: 'truck_original', // Unique truck entity ID
      billboardText: 'N4\n- 1' // Billboard text for this truck
    },
    // Mersing animation disabled
    /*
    {
      id: 'mersingAnimation', // Unique ID for the new animation
      czmlPath: '/road_553323706.czml', // Path to the newly generated CZML
      truckModelPath: '/CesiumMilkTruck.glb', // Reusing the same model
      durationSeconds: 60, // Assuming same duration, adjust if needed
      roadEntityId: 'road_553323706', // ID of the road polyline within the new CZML
      truckEntityId: 'truck_mersing', // Unique truck entity ID
      billboardText: 'SGV\n2' // Billboard text for this truck
    }
    */
  ],

  // Asset Fetching
  assetFetchLimit: 10000,
};

// You might also want to export the token separately if needed elsewhere,
// but generally keep its usage contained.
// export { CESIUM_ION_TOKEN };